import React, { useState, useEffect } from 'react';
import { SalesforceAPI } from '../services/api';
import './SalesforceInventory.css';

function SalesforceInventory() {
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const inventoryData = await SalesforceAPI.getInventory();
        setInventory(inventoryData);
        setError(null);
      } catch (err) {
        setError('Failed to fetch inventory. Please try again later.');
        console.error('Error fetching inventory:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchInventory();
  }, []);

  const filteredItems = inventory?.filter(item =>
    item.sku?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.description?.toLowerCase().includes(searchText.toLowerCase())
  ) || [];

  if (loading) {
    return <div className="loading">Loading inventory...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="inventory-container">
      <div className="inventory-list">
        <h2>Inventory Items</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search inventory..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="search-input"
          />
          <button 
            className="search-button"
            onClick={() => setSearchText('')}
          >
            Clear
          </button>
        </div>
        <div className="items">
          {filteredItems.map(item => (
            <div
              key={item.id}
              className={`inventory-item ${selectedItem?.id === item.id ? 'selected' : ''}`}
              onClick={() => setSelectedItem(item)}
            >
              <div className="item-header">
                <span className="item-sku">{item.sku}</span>
                <span className="item-quantity">Qty: {item.quantity}</span>
              </div>
              <div className="item-description">{item.description}</div>
              <div className="item-price">${parseFloat(item.price).toFixed(2)}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="item-details">
        {selectedItem ? (
          <>
            <h2>Item Details</h2>
            <div className="detail-content">
              <p><strong>ID:</strong> {selectedItem.id}</p>
              <p><strong>SKU:</strong> {selectedItem.sku}</p>
              <p><strong>Description:</strong> {selectedItem.description}</p>
              <p><strong>Quantity:</strong> {selectedItem.quantity}</p>
              <p><strong>Price:</strong> ${parseFloat(selectedItem.price).toFixed(2)}</p>
              <p><strong>Total Value:</strong> ${(parseFloat(selectedItem.quantity) * parseFloat(selectedItem.price)).toFixed(2)}</p>
            </div>
          </>
        ) : (
          <div className="no-selection">
            <p>Select an item to view details</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default SalesforceInventory;
